// src/components/UserMeet/CreateBreakoutModal.jsx
import React, { useState } from "react";
import Icon from "@/pages/MeetingRoom/ui/Icon";

export default function CreateBreakoutModal({ open, onClose, onCreate, loading }) {
  const [timeLimitMinutes, setTimeLimitMinutes] = useState(15);

  if (!open) return null;

  const handleCreate = () => {
    if (timeLimitMinutes < 1 || timeLimitMinutes > 120) return;
    onCreate?.(timeLimitMinutes);
  };

  return (
    <div
      className="jt-modalOverlay"
      role="dialog"
      aria-modal="true"
      onMouseDown={onClose}
    >
      <div
        className="jt-sheet"
        style={{ maxWidth: 420 }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="jt-sheetHead">
          <div className="jt-sheetTitle">
            <span style={{ marginRight: 8 }}>🔒</span>
            Start Private Meeting
          </div>
          <button className="jt-sheetClose" onClick={onClose}>
            <Icon name="close" />
          </button>
        </div>

        {/* Body */}
        <div className="jt-sheetBody">
          <p style={{ opacity: 0.75, marginBottom: 20, lineHeight: 1.5 }}>
            Start a private breakout room. Only people you invite can join.
            Your seat in the main meeting is kept.
          </p>

          {/* Time Limit */}
          <div style={{ marginBottom: 24 }}>
            <label
              style={{
                display: "block",
                marginBottom: 8,
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              Time Limit:{" "}
              <span style={{ color: "#4ADE80" }}>{timeLimitMinutes} minutes</span>
            </label>

            <input
              type="range"
              min={1}
              max={120}
              step={5}
              value={timeLimitMinutes}
              onChange={(e) => setTimeLimitMinutes(Number(e.target.value))}
              style={{ width: "100%", accentColor: "#4ADE80" }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: 12,
                opacity: 0.6,
                marginTop: 4,
              }}
            >
              <span>1 min</span>
              <span>60 min</span>
              <span>120 min</span>
            </div>
          </div>

          {/* Quick time buttons */}
          <div
            style={{
              display: "flex",
              gap: 8,
              flexWrap: "wrap",
              marginBottom: 24,
            }}
          >
            {[5, 10, 15, 30, 45, 60].map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setTimeLimitMinutes(t)}
                style={{
                  padding: "6px 14px",
                  borderRadius: 20,
                  border: "1px solid",
                  borderColor:
                    timeLimitMinutes === t
                      ? "#4ADE80"
                      : "rgba(255,255,255,0.2)",
                  background:
                    timeLimitMinutes === t
                      ? "rgba(74,222,128,0.15)"
                      : "rgba(255,255,255,0.05)",
                  color: timeLimitMinutes === t ? "#4ADE80" : "#fff",
                  cursor: "pointer",
                  fontSize: 13,
                  fontWeight: timeLimitMinutes === t ? 700 : 400,
                  transition: "all 0.18s",
                }}
              >
                {t}m
              </button>
            ))}
          </div>

          {/* Info box */}
          <div
            style={{
              padding: "12px 16px",
              borderRadius: 12,
              background: "rgba(74,222,128,0.08)",
              border: "1px solid rgba(74,222,128,0.2)",
              marginBottom: 24,
              fontSize: 13,
              lineHeight: 1.5,
              opacity: 0.9,
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: 4 }}>ℹ️ How it works</div>
            <ul style={{ margin: 0, paddingLeft: 16, opacity: 0.85 }}>
              <li>Your seat stays visible in the main meeting</li>
              <li>Only invited participants can join</li>
              <li>You can invite people after starting</li>
              <li>The meeting ends automatically after the time limit</li>
            </ul>
          </div>

          {/* Actions */}
          <div style={{ display: "flex", gap: 10 }}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                flex: 1,
                padding: "12px 0",
                borderRadius: 12,
                border: "1px solid rgba(255,255,255,0.15)",
                background: "rgba(255,255,255,0.05)",
                color: "#fff",
                cursor: "pointer",
                fontWeight: 600,
                fontSize: 15,
              }}
            >
              Cancel
            </button>

            <button
              type="button"
              onClick={handleCreate}
              disabled={loading}
              style={{
                flex: 2,
                padding: "12px 0",
                borderRadius: 12,
                border: "none",
                background: loading
                  ? "rgba(74,222,128,0.4)"
                  : "linear-gradient(135deg, #4ADE80, #16A34A)",
                color: "#062317",
                cursor: loading ? "not-allowed" : "pointer",
                fontWeight: 700,
                fontSize: 15,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
              }}
            >
              {loading ? (
                <>
                  <span
                    style={{
                      width: 16,
                      height: 16,
                      border: "2px solid #062317",
                      borderTopColor: "transparent",
                      borderRadius: "50%",
                      display: "inline-block",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  Starting...
                </>
              ) : (
                <>🔒 Start Private Meeting</>
              )}
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}